import React from "react";
import Button from "../../../components/ui/Button";
import { Zap, Video, Plus, DollarSign } from "lucide-react";
import { useNavigate } from "react-router-dom";

const QuickActions = () => {
  const navigate = useNavigate();

  const actions = [
    { label: "Go Live Now", icon: Video, color: "text-red-600", bg: "bg-red-50", hover: "hover:bg-red-100", path: "/dashboard/live" },
    { label: "New Post", icon: Plus, color: "text-purple-600", bg: "bg-purple-50", hover: "hover:bg-purple-100", path: "/dashboard/content" },
    { label: "Withdraw", icon: DollarSign, color: "text-emerald-600", bg: "bg-emerald-50", hover: "hover:bg-emerald-100", path: "/dashboard/wallet" },
  ];

  return (
    <div className="bg-white p-4 rounded-xl shadow-sm border border-slate-100">
      <h3 className="text-sm font-bold text-slate-700 uppercase mb-3 flex items-center">
        <Zap size={16} className="mr-2 text-amber-500" /> Quick Actions
      </h3>
      <div className="grid grid-cols-3 gap-3">
        {actions.map((action) => (
          <button
            key={action.label}
            onClick={() => navigate(action.path)}
            className={`flex flex-col items-center justify-center p-3 rounded-lg transition-colors ${action.bg} ${action.hover}`}
          >
            <div className={`p-2 rounded-full bg-white shadow-sm mb-2 ${action.color}`}>
              <action.icon size={20} />
            </div>
            <span className="text-[10px] sm:text-xs font-semibold text-slate-700 whitespace-nowrap">{action.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;
